// Generated by scripts/update-seeq-icons.js from src/svg/seeq/arrow-left-chevron.svg.
// Do not edit this file directly; update the source SVG and regenerate.
import type { IconDefinition, IconName } from '@fortawesome/fontawesome-common-types';

export const fcArrowLeftChevron = {
  prefix: 'fak',
  iconName: 'arrow-left-chevron' as IconName,
  icon: [
    1024,
    1024,
    [],
    '',
    'M220.2 512c0-25.6 10.2-46.1 25.6-66.6l399.3-430c20.5-20.5 51.2-20.5 71.7 0l71.7 66.5c20.5 20.5 20.5 51.2 0 71.7l-337.9 363.5 337.9 363.5c20.5 20.5 15.4 51.2 0 71.7l-71.7 56.3c-20.5 20.5-51.2 15.4-71.7 0l-399.3-430c-15.4-20.5-25.6-41-25.6-66.6z',
  ],
} satisfies IconDefinition;
